// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor_Indexed from "../Data.Functor.Indexed/index.js";
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var iapply = function (dict) {
    return dict.iapply;
};
var iapplyFirst = function (dictIxApply) {
    var iapply1 = iapply(dictIxApply);
    var imap = Data_Functor_Indexed.imap(dictIxApply.IxFunctor0());
    return function (a) {
        return function (b) {
            return iapply1(imap(Data_Function["const"])(a))(b);
        };
    };
};
var iapplySecond = function (dictIxApply) {
    var iapply1 = iapply(dictIxApply);
    var imap = Data_Functor_Indexed.imap(dictIxApply.IxFunctor0());
    return function (a) {
        return function (b) {
            return iapply1(imap(Data_Function["const"](identity))(a))(b);
        };
    };
};
export {
    iapply,
    iapplyFirst,
    iapplySecond
};
export {
    imap,
    ivoid,
    ivoidLeft,
    ivoidRight
} from "../Data.Functor.Indexed/index.js";
//# sourceMappingURL=index.js.map
